import { memo, useMemo } from 'react';
import {
  CheckCircle,
  Block,
  MonetizationOnOutlined,
  HelpOutlineOutlined,
} from '@mui/icons-material';
import { USDColor } from 'legacyfrontend/constants';

export const StatusIcon = memo(({ indicator }) => {
  const iconConfig = useMemo(() => {
    switch (indicator) {
      case 'INC':
        return { component: CheckCircle, color: USDColor };
      case 'CHA':
        return { component: MonetizationOnOutlined, color: '#293a8e' };
      case 'MIX':
        return { component: CheckCircle, color: '#FBBF24' };
      case 'NOF':
        return { component: Block, color: '#EF4444' };
      default:
        return { component: HelpOutlineOutlined, color: '#83888e' };
    }
  }, [indicator]);

  const { component: IconComponent, color } = iconConfig;
  return <IconComponent fontSize='small' sx={{ color }} />;
});
